// Centralized terminology constants for the brand refresh (CFPL-2368).
// Each constant holds TODAY'S current value. The visible-copy cutover happens
// later by flipping a value here in one place, not by editing call sites again.

// Member-facing app currently named "Compass".
export const PROVIDER_APP_NAME = 'Compass';

// Manager / change-leader platform currently named "Sage".
export const MANAGER_PLATFORM_NAME = 'Sage';

// Guided-exercises feature currently named "Moments".
export const EXERCISES_FEATURE_NAME = 'Moments';

// Plan-tier display labels.
export const PLAN_TIER_SIGNATURE_LABEL = 'Spring Signature';
export const PLAN_TIER_ACCESS_LABEL = 'Spring Access';

// Neurodiversity product currently named "Neurodiversity Hub".
export const NEURODIVERSITY_PRODUCT_NAME = 'Neurodiversity Hub';
